import { IStackItemStyles, Stack } from "@fluentui/react";
import { observer } from "mobx-react";
import { Header } from "../components/Header";
import PageRouter from "../components/pages/PageRouter";
import { LeftNav } from "./LeftNav";
import { IRootStateProps } from "../state/RootState";

const mainPageStyles: IStackItemStyles = {
	root: {
		width: '100%',
		minHeight: '100%',
	},
};

export const AuthenticatedApp = observer((props: IRootStateProps) => {
	return (
		<>
			<Stack>
				{props.RootState.hidePageHeader || (
					<Stack.Item align="auto">
						<Header
							RootState={props.RootState}
						></Header>
					</Stack.Item>
				)}

				{/* Everything below the top navigation */}
				<Stack.Item>
					<Stack horizontal>
						{/* Left nav - only if logged in and not in readonly mode */}
						{props.RootState.hidePageNavigation || (
							<Stack.Item>
								<LeftNav rootState={props.RootState}></LeftNav>
							</Stack.Item>
						)}

						{/* Main page content - either search results or routed page */}
						<Stack.Item styles={mainPageStyles}>
							<PageRouter rootState={props.RootState} />
						</Stack.Item>
					</Stack>
				</Stack.Item>
			</Stack>
		</>
	);
});
